import { ReportService, type ReportDO } from "./report.service"

export class ReportEmbed extends HTMLElement {
    private readonly slug: string = document.body.getAttribute("slug") ?? ""
    private readonly language: string | null = this.getAttribute("language")

    constructor(private reportService: ReportService = window.tbwServices.reportService) {
        super()
    }

    async connectedCallback() {
        if (!this.language || !this.verifyInput()) { return }
        if (window.tbwServices.authService.isAuthenticated) {
            await this.render()
        }
    }

    verifyInput() {
        return this.language === "fr" || this.language === "en"
    }

    async render() {
        this.innerHTML = '<p class="report-embed-loading">Loading...</p>'
        try {
            const content = await this.getReportUrl()
            this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                <div class="report-embed" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                    <iframe src="${this.language === 'en' ? content.englishURL : content.frenchURL}" style="width: 100%; height: 100%; border: none; flex: 1;"></iframe>
                </div>
            </div>
        </tbw-auth-state>
        `
        } catch {
            this.innerHTML = '<p class="report-embed-error">Unable to load report</p>'
        }
    }

    async getReportUrl(): Promise<ReportDO> {
        const content = await this.reportService.get(this.slug)
        return content
    }

}